import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { trophies } from "@/lib/trophies";

const API = process.env.REACT_APP_BACKEND_URL;

export default function GlobalTrophyTicker() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetch(`${API}/api/trophies/stats`)
        .then((r) => r.json())
        .then((d) => alive && setTotal(d.total))
        .catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    const unsub = trophies.subscribe(() => {
      setTotal((t) => (t == null ? t : t + 1));
      setTimeout(load, 900);
    });
    return () => {
      alive = false;
      clearInterval(iv);
      unsub();
    };
  }, []);

  if (total == null) return null;

  return (
    <span
      data-testid="global-trophy-ticker"
      className="inline-flex items-center gap-1.5 f-mono text-[9px] tracking-[0.25em] text-[#94A3B8]"
    >
      <Trophy size={11} color="#D97706" />
      <span className="f-orbitron text-[10px] font-bold text-[#D97706]">{total.toLocaleString()}</span>
      EARNED WORLDWIDE
    </span>
  );
}
